<template>
	<div class="featured-element" :class="{ featured: linkUrl }" @click="onClick" @keydown.enter="onClick" :style="style">
		<ExpandingDisclaimer v-if="useLegalExpansion" :add-collapsible="true" :containerWidth="setContainerWidth"
			:class="{ 'remove-margins': removeMargins }">
			<image-element :constrain="constraint" :class="[{ featured: !!linkUrl }, 'featured-class-element']" v-bind="$props"
				:style="{ width: imgWidth + 'px' }" ref="imageElement" />
		</ExpandingDisclaimer>
		<template v-else-if="isPersonalizedBanner">
			<image-element :adSrc="adSrc" :constrain="constraint" :class="{ featured: !!linkUrl }" v-bind="$props" />
		</template>
		<template v-else>
			<image-element :constrain="constraint" :class="{ featured: !!linkUrl }" v-bind="$props" />
		</template>

		<div v-if="isVisible">
			<product-click-regions v-for="(product, index) in products" :key="product.sku + index"
				:block-data="blockData" :is-visible="isVisible" :product="product" :banners="banners" :is-ad="isAd" :page="page" />
		</div>
	</div>
</template>

<script>
import ImageElement from "@/components/block/elements/ImageElement.vue";
import featureMixin from "@/mixins/featureMixin";
import blockElementMixin from "@/mixins/blockElementMixin";
import { mapGetters, mapState, mapActions } from "vuex";
import ProductClickRegions from "@/components/block/elements/ProductClickRegions.vue";
import ExpandingDisclaimer from "@/components/ExpandingDisclaimer";
import Lytics from "@/classes/Lytics";

export default {
	name: "AdElement",
	components: { ProductClickRegions, ImageElement, ExpandingDisclaimer },
	mixins: [featureMixin, blockElementMixin],
	data() {
		return {
			adSrc: null,
			banners: null,
			isAd: false,
			containerWidth: '',
			featurePath: 'personalizedBanners',
			isPersonalizedChecked: false,
			themeName: null,
			personalizedAd: null,
			halfPageGrid: false,
		}
	},
	async mounted() {
		this.isHalfPageGrid();
		if (this.isPersonalizedBanner) {
			await this.isPersonalizedAd()
		}

	},
	computed: {
		...mapState(['pages']),
		...mapGetters('config', ['features', 'branding']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapGetters(['hasBaseBars', 'isCTC']),
		...mapGetters('landingPage', ["currentFlyer"]),
		...mapGetters('ctUser', ['hasPersonalizedAds', 'canViewPersonalizedBanner']),
		...mapGetters(['content', "language"]),
		pageHeight() {
			let ph = this.page.pageHeight;
			if (this.hasBaseBars) {
				if (this.halfPageGrid) {
					ph += 31
				} else
				ph += this.config.value || 31;
			}
			return ph;
		},
		pageWidth() {
			return this.page.pageWidth;
		},
		constraint() {
			if (this.flyerOrientation === 'vertical') {
				return { 'width': this.pageWidth }
			}
			return { 'height': this.pageHeight }
		},
		products() {
			return this.blockData.products;
		},
		linkUrl() {
			return this.blockData.linkUrl;
		},
		useLegalExpansion() {
			return this.isCTC && this.page.name.substr(0, 5) === "Legal" && this.displayMode === "mobile";
		},
		isPersonalizedBanner() {
			return this.canViewPersonalizedBanner && this.page.name.toLowerCase().includes("personalized");
		},
		removeMargins() {
			let isPoweredByTC = this.features?.poweredByTC?.enabled
			return isPoweredByTC && this.pages.slice(-1).pop().name.substr(0, 5) === "Legal" && this.displayMode === "mobile"
		},
		imgWidth() {
			return parseFloat(this.page?.pageWidth) - 35;
		},
		setContainerWidth() {
			return `${this.page.pageWidth}px`;
		},
		style() {
			if (this.useLegalExpansion) return;
			const aspec = this.blockData.aspectRatio;
			if (this.flyerOrientation === 'vertical') {
				return { 'width': `${this.pageWidth}px`, 'height': `${this.pageWidth / aspec}px` }
			}
			return { 'width': `${this.pageHeight * aspec}px`, 'height': `${this.pageHeight}px` }
			
		}
	},
	methods: {
		...mapActions('ctUser', ['loadPersonalizedAds']),
		isHalfPageGrid() {
		 this.pages.some(page => {
				if (page.grids?.desktop.colCount === 60)
				  this.halfPageGrid = true;
			});
		},
		onClick() {
			console.log('Ad Click')
			if (this.isAd) {
				window.open(this.banners?.linkUrlEn)
				return
			}
			if (this.blockData.linkUrl) {
				window.open(this.blockData.linkUrl)
				Lytics.TriggerAdClick({
					ad_name: this.page.name,
					ad_url: this.blockData.linkUrl,
					ad_image_url: this.blockData.images[0]?.image,
					ad_size: `${this.page.pageWidth}x${this.page.pageHeight}`,
					total_click_include: true
				})
			}

		},
		async isPersonalizedAd() {
			this.banners = await this.loadPersonalizedAds();
			if (this.banners) {
				this.themeName = this.banners.themeName;
                this.isPersonalizedChecked = true;
				this.constructPersonalizedAd();
			}

		},
		constructPersonalizedAd() {
			const displayMode = this.displayMode.toLowerCase();
			const accessKey = this.config?.accessKey || '';
			if (displayMode === 'desktop' && this.flyerOrientation  !== 'vertical') {
				this.personalizedAd = `${this.banners?.desktopBannerUrl}${accessKey}`
			} else if (displayMode === `tablet` || (displayMode === `desktop` && this.flyerOrientation  === 'vertical')) {
			
				this.personalizedAd = `${this.banners?.tabletBannerUrl}${accessKey}`
			} else {
				this.personalizedAd = `${this.banners?.mobileBannerUrl}${accessKey}`
			}
			this.loadImage();

		},
		loadImage() {
			if (this.personalizedAd && this.themeName !== null && this.themeName !== undefined && this.themeName !== '') {
                const img = new Image();
				img.src = this.personalizedAd;
				img.onload = () => {
					this.isAd = true
					this.adSrc = this.personalizedAd;
				};
				img.onerror = () => {
					this.isAd = false
					this.adSrc = null;
				};
			}
			else {
				this.isAd = false
				this.adSrc = null;

			}
		}



	},

	watch: {
		displayMode() {
			if (this.isPersonalizedBanner && !this.isPersonalizedChecked) {
				this.isPersonalizedAd();
			} else if (this.isPersonalizedChecked && this.themeName) {
				this.constructPersonalizedAd()
			}
		},
		flyerOrientation() {
			if (this.isPersonalizedBanner && !this.isPersonalizedChecked) {
				this.isPersonalizedAd();
			} else if (this.isPersonalizedChecked && this.themeName) {
				this.constructPersonalizedAd()
			}
		},
		isPersonalizedBanner() {
			if (this.isPersonalizedBanner && !this.isPersonalizedChecked) {
				this.isPersonalizedAd();
			}
		}

	}
}
</script>

<style scoped>
.featured-element {
	position: relative;
}

.featured {
	cursor: pointer;
}

.overlay {
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	position: absolute;
	will-change: transform, opacity;
}

.featured-element .overlay {
	transition: filter 0.3s;
}

.featured-element:hover .overlay {
	pointer-events: auto;
}

.expanding-disclaimer.remove-margins {
	margin-bottom: 0;
}
</style>
